<template>
    <div class="my_question">
        <div class="menu_list flex">
            <div class="menu_one flex flexcolumn Flexalign cursor_pointer" v-for="(item, index) in menuList"
                :key="index" @click="chaneMenu(item)" :class="[item.value == selectMenu ? 'active_menu' : '']">
                {{ item.label }}
            </div>
        </div>
        <div class="question_list hidden_scroll" v-if="questionList.length">
            <div class="question_one mt-20 mb-10" v-for="(item, index) in questionList" :key="index">
                <div class="flex Flexalign FlexBetween question_one_top">
                    <div class="flex Flexalign">
                        <el-image class="question_active_icon" :src="iconPath('question_active_icon.png')"></el-image>
                        <div class="ml-5">你的提问</div>
                    </div>
                    <div>
                        {{ $Moment(item.askTime).format("MM-DD")
                        }}<span class="pl-10">{{ $Moment(item.askTime).format("HH:mm") }}</span>
                    </div>
                </div>
                <div class="mt-10">{{ item.askContent }}</div>
                <div class="img_list flex FlexWrap">
                    <div class="img_one mt-15 mr-15" v-for="(sitem, sindex) in item.askImgList" :key="sindex">
                        <el-image class="ask_img" :src="sitem.url" :preview-src-list="[sitem.url]"></el-image>
                    </div>
                </div>
                <div class="file_list">
                    <div class="file_one p-10 mt-15 mr-15 cursor_pointer flex Flexalign" v-for="(sitem, sindex) in item.askFileList"
                        :key="sindex" @click="openFile(sitem)">
                        <el-image class="file_icon mr-5" :src="iconPath('file_icon.png')"></el-image>
                        {{ sitem.name }}
                    </div>
                </div>
                <div class="answer_content mt-15" v-if="selectMenu == 2">
                    <div class="flex Flexalign FlexBetween question_one_top">
                        <div class="flex Flexalign">
                            <el-image class="question_active_icon" :src="iconPath('answer_active_icon.png')"></el-image>
                            <div class="ml-5">{{ item.tutorName }}的回答</div>
                        </div>
                        <div>
                            {{ $Moment(item.replyTime).format("MM-DD")
                            }}<span class="pl-10">{{ $Moment(item.replyTime).format("HH:mm") }}</span>
                        </div>
                    </div>
                    <div class="mt-10">{{ item.replyContent }}</div>
                    <div class="img_list flex FlexWrap">
                        <div class="img_one mt-15 mr-15" v-for="(sitem, sindex) in item.answerImgList" :key="sindex">
                            <el-image class="ask_img" :src="sitem.url" :preview-src-list="[sitem.url]"></el-image>
                        </div>
                    </div>
                    <div class="file_list">
                        <div class="file_one p-10 mt-15 mr-15 cursor_pointer flex Flexalign"
                            v-for="(sitem, sindex) in item.answerFileList" :key="sindex" @click="openFile(sitem)">
                            <el-image class="file_icon mr-5" :src="iconPath('file_icon.png')"></el-image>
                            {{ sitem.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <moe-empty url="moe_empty_bg_img.png" emptyText="暂无问答"></moe-empty>
        </div>
    </div>
</template>

<script>
export default {
    name: "GjkcH5MyQuestion",

    data() {
        return {
            menuList: [
                { label: "已回答", value: 2 },
                { label: "未回答", value: 1 },
            ],
            selectMenu: 2,
            listQuery: {
                status: 2,
                keyword: "",
                startTime: "",
                endTime: "",
            },
            questionList: [],
        };
    },

    mounted() {
        this.getMyQuestion();
    },

    methods: {
        chaneMenu(info) {
            this.selectMenu = info.value;
            this.listQuery.status = info.value;
            this.getMyQuestion();
        },
        getMyQuestion() {
            this.$Api.user
                .getMyQuestion(this.listQuery)
                .then((res) => {
                    this.questionList = res.data.data.list.map((item) => {
                        return {
                            ...item,
                            askImgList: this.getImgList(item.askAttach, "img"),
                            askFileList: this.getImgList(item.askAttach, "file"),
                            answerImgList: this.getImgList(item.replyAttach, "img"),
                            answerFileList: this.getImgList(item.replyAttach, "file"),
                        };
                    });
                    console.log(this.questionList);
                })
                .catch(() => { });
        },
        // 拆解附件中的图片
        getImgList(list, type) {
            let aaa = [];
            let bbb = [];
            list.forEach((item) => {
                if (this.isImage(item.mimeType)) {
                    aaa.push(item);
                } else {
                    bbb.push(item);
                }
            });
            if (type == "img") {
                return aaa;
            } else {
                return bbb;
            }
        },
        isImage(file) {
            return file.startsWith("image/") || /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name);
        },
        openFile(info) {
            window.open(info.url);
        },
    },
};
</script>

<style lang="scss" scoped>
.my_question {
    min-height: 500px;

    .menu_list {
        .menu_one {
            line-height: 50px;
            margin: 0 10px;
            position: relative;
            color: rgba(153, 153, 153, 1);
        }

        .active_menu {
            color: #13d6aa;
            font-weight: 600;
        }

        .line_active {
            position: absolute;
            bottom: 0;
            width: 50px;
            height: 2px;
            background: #13d6aa;
        }
    }

    .question_list {
        max-height: 800px;
        overflow-y: auto;

        .question_one {
            .question_one_top {
                font-size: 14px;
                color: #606060;

                .question_active_icon {
                    width: 20px;
                    height: 20px;
                }
            }

            .img_list {
                .img_one {
                    .ask_img {
                        width: 140px;
                        height: 140px;
                        border-radius: 12px;
                    }
                }
            }

            .file_list {
                .file_one {
                    background: #f1f6fc;
                    border-radius: 6px;
                    width: fit-content;
                    font-size: 12px;
                    color: #1B1B48;
                    .file_icon{
                        width: 18px;
                        height: 18px;
                    }
                }
            }

            .answer_content {
                background: #f7f7f7;
                border-radius: 10px;
                padding: 15px;
                box-sizing: border-box;

                .img_list {
                    .img_one {
                        .ask_img {
                            width: 132px;
                            height: 132px;
                            border-radius: 12px;
                        }
                    }
                }
            }
        }
    }
}
</style>
